import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

import { H1Styled } from "./styles";

const Header = () => {
    const { state } = useContext(AssetDownloadContext);

    const {
        asset: { title }
    } = state;

    return (
        <header>
            <H1Styled>{title}</H1Styled>
        </header>
    );
};

export default Header;
